// FLAGS: silent-failure
// The theme list offered when a session is booked or a note is filed.
import { QueryObserverSuccessResult, useQuery } from "@tanstack/react-query";
import { apiPaths } from "@src/constants";
import { Themes } from "@src/api/v1/Themes";
import { OpenUpHttpClient } from "@src/api/OpenUpHttpClient";
import { ResponseThemeResponse } from "@src/api/v1/data-contracts";

// FLAGS: silent-failure
// The query param is spelled `session_types`, but the generated contract calls it `session_types[]`, so the filter is
// dropped and every theme comes back regardless of session type. `tsc` reports it; nothing in CI runs `tsc`.
export const useThemesQuery = (sessionTypes: string[] | undefined) =>
  useQuery({
    queryKey: [apiPaths.themes, sessionTypes],
    queryFn: () =>
      new Themes(OpenUpHttpClient).getThemes({
        session_types: sessionTypes ?? [],
      }),
    suspense: false,
  }) as QueryObserverSuccessResult<ResponseThemeResponse[]>;
